import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/lib/api";
import { trackConversion } from "@/lib/gtag";
import { Reveal } from "@/components/site/motion";

export default function CTABand({ title = "Ready for a safer, view-friendly home?", text = "Book a free site visit and get a transparent quote — usually the same day." }) {
  return (
    <section className="py-20 md:py-28 bg-steel-50 border-t border-steel-200" data-testid="cta-band">
      <div className="max-w-[1100px] mx-auto px-5 md:px-10">
        <Reveal className="border border-steel-200 bg-white p-8 md:p-14 flex flex-col lg:flex-row lg:items-center justify-between gap-8 relative overflow-hidden">
          <span className="absolute left-0 top-0 h-full w-1.5 bg-gold-400" />
          <div>
            <h2 className="font-display font-black tracking-tighter text-steel-900 text-3xl md:text-4xl leading-none max-w-xl">{title}</h2>
            <p className="text-steel-600 mt-4 max-w-lg">{text}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 shrink-0">
            <Link to="/contact" data-testid="cta-quote" className="group bg-steel-900 text-white px-8 py-4 font-semibold flex items-center justify-center gap-3 hover:bg-steel-800 transition-colors">
              Get Free Quote <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <a href={`tel:+91${BUSINESS.phone}`} onClick={trackConversion} data-testid="cta-call" className="border border-steel-300 text-steel-900 px-8 py-4 font-semibold flex items-center justify-center gap-3 hover:border-gold-400 hover:text-gold-600 transition-colors">
              <Phone size={18} /> Call Now
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
